// @flow


type Props = {
  balanceAvailable: number,
  cost: number | null,
  freeCount: number,
  noMoreAvailableToAdd: boolean,
}

const getIsSourceItemDisabled = ({
  balanceAvailable,
  cost,
  freeCount,
  noMoreAvailableToAdd,
}: Props) => {
  if (noMoreAvailableToAdd) {
    return 'order_request_sales_put_on_food_complex_enouth'; // 'Нельзя добавить более одного комплекта'
  }

  if (cost === null) {
    return 'order_request_sales_put_on_food_complex_cost_undefined'; // 'Цена комплекта не определена'
  }

  if (freeCount > 0) {
    return '';
  }

  return (
    balanceAvailable < cost
      ? 'order_request_sales_put_on_food_complex_insufficient' // 'Недостаточно средств'
      : ''
  );
};

export default getIsSourceItemDisabled;
